import { Headline, createHeadline } from '@vfde-brix/ws10/headline';
import { HtmlId } from '../enum';
import { mountComponent } from '../util/mount';
import { NO_PATTERN_BUSINESS_LOGIC } from '@vfde-brix/ws10/core';
import { formatBandwidth, formatText } from '../util/formatter';
import { JarvisProduct } from '../interface';

export const mountHeadline = (id: HtmlId) =>
    mountComponent(id, createHeadline, NO_PATTERN_BUSINESS_LOGIC);

export const updateResultCardHeadline = (comp: Headline | null, product?: JarvisProduct, text?: string) => {
    const download = formatBandwidth(product?.download.toString() || '');

    comp?.update({ stdContent: formatText(text, download) });
    comp?.toggleContainer(!text);
};
